import {Injectable} from '@angular/core'

@Injectable()
export class FilterService {

    filters = {}

}
